exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".capitalize-first[data-v-2846cac6]{text-transform:capitalize}.font-size-18[data-v-2846cac6]{font-size:18px}@media(min-width: 1200px){.login-prompt[data-v-2846cac6]{margin-top:30px}}@media(max-width: 575px){.xspl40[data-v-2846cac6]{padding-left:40px}}", ""]);

// exports
